import { SettingFilled } from "@ant-design/icons";
import s from "./color.module.scss";
import { useState, useContext } from "react";
import { ColorContext } from "../../context/colorContext";
import { Switch } from "antd";
import { useTranslation } from "react-i18next";

export const Color = () => {
  const [active, setActive] = useState(false);
  const { i18n } = useTranslation();
  const arr = ["red", "green", "blue", "yellowgreen", "violet", "#ec9131"];
  return (
    <div style={{ right: active ? 0 : -150 }} className={s.color}>
      <SettingFilled
        onClick={() => setActive((prev) => !prev)}
        className={s.setting}
      />
      <div className={s.lang}>
        <Switch
          onChange={(checked) => {
            if (checked) i18n.changeLanguage("ru");
            else i18n.changeLanguage("en");
          }}
          unCheckedChildren={
            <span style={{ color: "#000", fontWeight: 600 }}>EN</span>
          }
          checkedChildren={
            <span style={{ color: "#000", fontWeight: 600 }}>RU</span>
          }
        />
      </div>
      <div className={s.colors}>
        {arr.map((v) => (
          <ColorCard color={v} key={v} />
        ))}
      </div>
    </div>
  );
};

export const ColorCard = ({ color }) => {
  const { setColor } = useContext(ColorContext);
  return (
    <div className={s.colorCard}>
      <div
        onClick={() => setColor(color)}
        style={{ backgroundColor: color }}
        className={s.rang}
      ></div>
    </div>
  );
};
